// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import api from './api';
// import '@/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import _ from 'lodash'
import 'babel-polyfill'
import VueJsonp from 'vue-jsonp'
import '../static/css/xctips.css'
import '../static/js/jquery.min.js'
import '../static/js/jquery.xctips'
import filters from './filters';
import './basic.css';

Vue.use(ElementUI);

Vue.use(VueJsonp)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$_ = _

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = binding.value
  }
})

/* eslint-disable no-new */
new Vue({
  // el: '#app',
  // router,
  // store,
  // components: { App },
  // template: '<App/>',
  router,
  store,
  render: h => h(App),
  async created() {
    await store.dispatch('setWebConfig');
    await store.dispatch('setSwitchList');
    this.$mount('#app');
  }
});



// WEBPACK FOOTER //
// ./src/main.js